import http from './interceptor';

export function toQueryString(values) {
  return Object.keys(values)
    .map(key => {
      const val = values[key];
      return key + '=' + (val != null ? encodeURIComponent(val) : '');
    })
    .join('&');
}

const request = ({
  url = '',
  method = 'GET',
  headers = {},
  params = {},
  data = {},
}) => {
  const comHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...headers,
  };

  switch (method.toUpperCase()) {
    case 'GET':
      return http.get(url, { headers: comHeaders, params });
    case 'POST':
      return http.post(url, data, { headers: comHeaders, params });
    case 'POST_FORMDATA':
      return http.post(url, data, { headers: comHeaders, params });
    case 'PUT':
      return http.put(url, data, { headers: comHeaders, params });
    case 'DELETE':
      return http.delete(url, { headers: comHeaders, params, data });
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
};

export default request;
